export default __webpack_public_path__ + "static/media/CNo.73-0.70e6e56b.jpg";